import React, { useEffect, useState } from "react";
import Style from "../../style/eventcategory.module.scss";

const EventCategory = () => {
  const [data, setData] = useState<any | []>([]);
  useEffect(() => {
    fetch("/data/event.json")
      .then((value) => {
        return value.json();
      })
      .then((res) => {
        setData(res.events);
      });
  }, []);

  const categoryIconMap: { [key: string]: string } = {
    Travel: "https://cdn-icons-png.flaticon.com/512/854/854878.png",
    Health: "https://cdn-icons-png.flaticon.com/512/2972/2972885.png",
    Environment: "https://cdn-icons-png.flaticon.com/512/927/927567.png",
    Education: "https://cdn-icons-png.flaticon.com/512/3135/3135755.png",
    Finance: "https://cdn-icons-png.flaticon.com/512/1907/1907551.png",
    Technology: "https://cdn-icons-png.flaticon.com/512/2721/2721298.png",
    Food: "https://cdn-icons-png.flaticon.com/512/1046/1046784.png",
    Business: "https://cdn-icons-png.flaticon.com/512/3062/3062634.png",
    Arts: "https://cdn-icons-png.flaticon.com/512/1250/1250615.png",
    Logistics: "https://cdn-icons-png.flaticon.com/512/201/201623.png",
  };

  const categoryData = Array.from(
    new Map(data.map((item: any) => [item.categories[0], item])).values()
  );

  const countByCategory = (category: string) =>
    data.filter((item: any) => item.categories[0] === category).length;
  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        <div className={Style.mainbox}>
          <h2>Browse by Category</h2>
          <div className={Style.content}>
            <ul>
              {categoryData.slice(0, 5).map((item: any) => {
                const category = item.categories[0];
                return (
                  <>
                    {" "}
                    <li key={category}>
                      <a
                        href={`/event/category/${category
                          .toLowerCase()
                          .replaceAll(" ", "-")}`}
                      >
                        <img
                          src={
                            categoryIconMap[category] ||
                            "https://cdn-icons-png.flaticon.com/512/565/565547.png"
                          }
                          alt={category}
                        />
                        <span>{category}</span>
                        <strong>{countByCategory(category)}.0 Events</strong>
                      </a>
                    </li>
                  </>
                );
              })}
              <li>View All</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCategory;
